import { render } from "./Reclamo.vue?vue&type=template&id=09dc778c&scoped=true"
import script from "./Reclamo.vue?vue&type=script&lang=js"
export * from "./Reclamo.vue?vue&type=script&lang=js"

import "./Reclamo.vue?vue&type=style&index=0&id=09dc778c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09dc778c"]])

export default __exports__